import { sizes } from '../configs/theme';

export function parse(size) {
    return `${size / sizes.font_size_base}rem`;
}
